import {
	ChangePasswordPayload,
	GuestDetails,
	updateGuestDetails,
} from "@/api/register";
import { MutationOptionsWithoutFn } from "@/types/types";
import { useMutation } from "@tanstack/react-query";

type ChangePasswordArgs = {
	guestId: number;
	payload: ChangePasswordPayload;
};

export default function useChangePassword(
	options?: MutationOptionsWithoutFn<GuestDetails, ChangePasswordArgs>,
) {
	return useMutation({
		mutationFn: ({ guestId, payload }: ChangePasswordArgs) =>
			updateGuestDetails(guestId, payload),
		...options,
	});
}
